import { BaseClient } from "../client";
import { TAnuncioHistorico } from "./offer.types";

interface ApiResponse {
  success: boolean;
  message: string;
  data: TAnuncioHistorico[];
}

export const getOfferStory = async (anuncioId: string) => {
    try {
        const url = `/Anuncios/Get/HistoricoAnuncio?idAnuncio=${anuncioId}`;
        
        const response = await BaseClient.get(url);
        return response.data;
    } catch (error : any) {
      return error.response.data ?? {success:false, message: "Erro. Contate o administrador."};
    }
};